var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import * as ReactDOM from "react-dom";
import { DropDownListPortalController } from "./DropDownListPortalController";
import { observer } from "mobx-react";
let DropDownListPortal = class DropDownListPortal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.hideHandler = (e) => {
            const target = e.target;
            if (target.nodeType === 9 || (target.nodeType === 1 && !target.hasAttribute("data-drop-down-keep"))) {
                this.props.hideHandler(e);
            }
        };
        this.hideHandlerOnScroll = (e) => {
            if (!((e.target instanceof HTMLElement) && (e.target).hasAttribute("data-drop-down-scrollable"))) {
                this.props.hideHandler(e);
            }
        };
        this.prepareStyleProperties = () => {
            return this.controller.prepareStyleProperties(this.list.current, this.rootElement.current);
        };
        this.rootElement = this.props.rootElement;
        this.list = React.createRef();
        this.controller = new DropDownListPortalController();
        this.state = {
            heigth: this.controller.heigth
        };
    }
    componentDidMount() {
        document.addEventListener("click", this.hideHandler, false);
        this.prepareStyleProperties();
        this.setState({
            heigth: this.controller.heigth
        });
        window.addEventListener("resize", this.props.hideHandler);
        document.addEventListener("scroll", this.hideHandlerOnScroll, true);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.hideHandler, false);
        window.removeEventListener("resize", this.props.hideHandler);
        document.removeEventListener("scroll", this.hideHandlerOnScroll, true);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.heigth !== this.state.heigth || prevProps.children !== this.props.children) {
            this.prepareStyleProperties();
        }
    }
    render() {
        const classes = ["rj-drop-down-list", ...this.props.classesModifier];
        return (ReactDOM.createPortal(React.createElement("div", { className: classes.join(" "), ref: this.list, style: this.controller.styleProperties }, this.props.children), document.body));
    }
};
DropDownListPortal = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], DropDownListPortal);
export { DropDownListPortal };
//# sourceMappingURL=DropDownListPortal.js.map